"use client";

import { SearchProvider } from "@/components/layout/search-context";
import type { ReactNode } from "react";

export function SearchProviderRoot({ children }: { children: ReactNode }) {
  return <SearchProvider>{children}</SearchProvider>;
}
